import { render, staticRenderFns } from "./SearchPop.vue?vue&type=template&id=36ed5e5c&scoped=true&"
import script from "./SearchPop.vue?vue&type=script&lang=js&"
export * from "./SearchPop.vue?vue&type=script&lang=js&"
import style0 from "./SearchPop.vue?vue&type=style&index=0&id=36ed5e5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed5e5c",
  null
  
)

export default component.exports